import React from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { XMarkIcon, DocumentTextIcon, ArrowUpTrayIcon, SparklesIcon } from '@heroicons/react/24/outline';

interface NewDocumentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDocumentTypeSelect: (type: 'electronic' | 'upload' | 'ai', path?: string) => void;
  selectedPath?: string;
}

const NewDocumentModal: React.FC<NewDocumentModalProps> = ({
  isOpen,
  onClose,
  onDocumentTypeSelect,
  selectedPath,
}) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <div className="flex justify-between items-center mb-4">
                  <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                    Novo Documento
                  </Dialog.Title>
                  <button
                    onClick={onClose}
                    className="text-gray-400 hover:text-gray-500"
                  >
                    <XMarkIcon className="h-6 w-6" />
                  </button>
                </div>

                <div className="mt-4 space-y-4">
                  <button
                    onClick={() => onDocumentTypeSelect('electronic', selectedPath)}
                    className="w-full p-4 text-left border rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <div className="flex items-center">
                      <DocumentTextIcon className="h-6 w-6 text-gray-400 mr-3" />
                      <div>
                        <h4 className="text-sm font-medium text-gray-900">Documento Eletrônico</h4>
                        <p className="mt-1 text-sm text-gray-500">
                          Crie um novo documento usando um template ou comece do zero
                        </p>
                      </div>
                    </div>
                  </button>

                  <button
                    onClick={() => onDocumentTypeSelect('ai', selectedPath)}
                    className="w-full p-4 text-left border rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-purple-500"
                  >
                    <div className="flex items-center">
                      <SparklesIcon className="h-6 w-6 text-purple-400 mr-3" />
                      <div>
                        <h4 className="text-sm font-medium text-gray-900">Documento com IA</h4>
                        <p className="mt-1 text-sm text-gray-500">
                          Crie um documento usando inteligência artificial para gerar conteúdo
                        </p>
                      </div>
                    </div>
                  </button>

                  <button
                    onClick={() => onDocumentTypeSelect('upload', selectedPath)}
                    className="w-full p-4 text-left border rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-green-500"
                  >
                    <div className="flex items-center">
                      <ArrowUpTrayIcon className="h-6 w-6 text-green-400 mr-3" />
                      <div>
                        <h4 className="text-sm font-medium text-gray-900">Upload de Arquivo</h4>
                        <p className="mt-1 text-sm text-gray-500">
                          Faça upload de um arquivo existente
                        </p>
                      </div>
                    </div>
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default NewDocumentModal; 